// @flow
import * as React from 'react'
import { parseHostname } from '@ta-interaktiv/parse-hostname'

import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import styles from './styles.module.scss'
import articles from './links.yml'

function ArticleLink({
  articlePath,
  title,
  lead
}: {
  articlePath: string
  title: string
  lead: string
}) {
  return (
    <a
      href={`https://www.${parseHostname().publicationDomain}${articlePath}`}
      target='_parent'
      className={`item ${styles.linkItem}`}
    >
      <i className='external link icon middle aligned' />
      <div className='content'>
        {lead}
        <div className='header'>{title}</div>
      </div>
    </a>
  )
}

export function ArticleList() {
  return (
    <aside className='ui segment grey article-list'>
      <h4 className='ui infographic tiny header'>
        Weitere Storys zum Hotelrating:
      </h4>
      <div className='ui icon very relaxed divided infographic list'>
        {articles.map(article => (
          <ArticleLink key={article.articlePath} {...article} />
        ))}
      </div>
    </aside>
  )
}
